export enum POC_TAG_SOURCES {
  CONTACT_TAB = 'CONTACT_TAB',
  FEEDBACK_FORM = 'FEEDBACK_FORM'
}
